export const parseURLToId = (string:string)=>{
    if(string.length<20){
        return string
    }
    const startIdx = string.indexOf("video/") + "video/".length;
    const endIdx = string.indexOf("?", startIdx);
    const videoId = string.substring(startIdx, endIdx);
    return videoId
}